import { action, observable } from 'mobx';
import Store from '~/glm/models/store';
import ErrorHandler from '~/glm/utils/error-handler';
import ExperimentsApi, { CONTROL_FALLBACK } from '../utils/experiments.api';

/*
 * This store was originally created to run an experiment for a WWS CTA on GLM.
 * It was generalized and left here so that if/when a new experiment is run on GLM,
 * this can be reused as a starting point.
 */

class ExperimentsStore extends Store {
  @observable isReady = false;
  @observable experimentAssignment = CONTROL_FALLBACK;

  constructor(experimentId = '') {
    super();
    this.experimentId = experimentId;
  }

  @action
  initExperimentAssignments(memberId) {
    return this.getExperimentAssignment(memberId)
      .then(() => {
        this.setProp('isReady', true);
      })
      .catch(error => {
        this.setProp('isReady', true);
        ErrorHandler.notify({
          name: 'initializing experiment assignments - flipper fetch failed',
          context: { memberId, error },
        });
      });
  }

  getExperimentAssignment(memberId) {
    return ExperimentsApi.getFlipperAssignmentForExperiment(this.experimentId, memberId)
      .then(assignment => {
        this.updateExperimentAssignment(assignment);
      })
      .catch(error => {
        this.updateExperimentAssignment(CONTROL_FALLBACK);
        ErrorHandler.notify({
          name: `initializing experiment assignments - flipper fetch failed, falling back to ${CONTROL_FALLBACK}`,
          context: { memberId, error },
        });
      });
  }

  @action updateExperimentAssignment(assignment) {
    this.experimentAssignment = assignment;
  }
}

export default ExperimentsStore;
